import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Middleware from "./Middleware";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
require("dotenv").config();

ReactDOM.render(
  <React.StrictMode>
    <Middleware />
  </React.StrictMode>,
  document.getElementById("root")
);
serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
